import { mapGetters } from "vuex";
import { debounce, throttle } from "lodash";
import { decodeHtml } from "@/router/utils";
import { XMarkIcon } from "@heroicons/vue/24/outline";

export default {
	name: "SearchBar",
	components: {
		XMarkIcon,
	},
	data() {
		return {
			isSmallScreen: window.innerWidth <= 600,
		};
	},
	methods: {
		onInput: debounce(
			throttle(function (event) {
				this.error = null;
				this.$emit("termChange", event.target.value);
			}, 250),
			500
		),
		handleResize() {
			this.isSmallScreen = window.innerWidth <= 600;
		},
		close() {
			this.$emit("close");
		},
		decodeHtml,
	},
	computed: {
		...mapGetters("languages", ["languages", "activeLanguage"]),
		...mapGetters("staticContent", ["getTranslations"]),
		...mapGetters("processes", ["currentCategory", "currentSector"]),
		placeholder() {
			if (this.isSmallScreen && this.activeLanguage.two_digit_code === "en") {
				return "Search " + this.currentSector?.title;
			} else if (this.activeLanguage.two_digit_code === "en") {
				return (
					"Search " +
					this.currentSector?.title +
					" ..."
				);
			}

			if (this.activeLanguage.two_digit_code != "en") {
				return this.getTranslations(
					"search ..."
				);
			}
		},
	},
	mounted() {
		window.addEventListener("resize", this.handleResize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleResize);
	},
};
